import React from "react";
import Special from "./Special/Special";

const Myself = ({ house, gift }) => {
  return (
    <div>
      <h4>Myself</h4>
      <p>
        <small>House: {house}</small>
      </p>
      <section>
        <Special house={house}></Special>
      </section>
    </div>
  );
};

export default Myself;
